//
// SchemaItem
//
// A simple schema item (definition, class, or field), with icon, name and label

import { observer } from 'mobx-react-lite'

import { IconTile } from '.'
import { HView, View, VView } from '../appview'
import { ClassData } from '../stores/data/ClassData'
import { DefinitionData } from '../stores/data/DefinitionData'
import { FieldData } from '../stores/data/FieldData'
import { ItemTitleSubtitle } from '../workspaces/components'

export const SchemaItem = observer(function SchemaItem({
    item,
    className,
    iconplaceholder,
    ...other
}) {
    let classes = 'cc-SchemaItem'
    if (className) classes += ' ' + className
    const thumbsize = 20
    const lineheight = 32

    if (!item) {
        return (
            <IconTile
                className={classes + ' cc-dimmed'}
                width={thumbsize}
                icon={iconplaceholder ? iconplaceholder : 'plus'}
                anchor="left"
                {...other}
            />
        )
    }

    const iconname =
        item instanceof DefinitionData
            ? 'definition'
            : item instanceof ClassData
              ? 'class'
              : item instanceof FieldData
                ? 'field'
                : 'empty'

    return (
        <HView
            className={classes}
            {...other}
            gap={5}
            style={{
                flexBasis: lineheight + 'px',
                minHeight: lineheight,
                maxHeight: lineheight,
            }}
        >
            <View
                className="cc-noline"
                style={{
                    flexBasis: thumbsize + 'px',
                    minWidth: thumbsize,
                    maxWidth: thumbsize,
                }}
            >
                <IconTile width={thumbsize} icon={iconname} anchor="left" {...other} />
            </View>
            <VView grow>
                <ItemTitleSubtitle item={item} ellipsisAfter={32} />
            </VView>
        </HView>
    )
})
